import React, { Component } from 'react';
//import DwoComponentWeb from 'dwo-trading/dwo-component/bin/web';
import { createContainer } from 'dwomuster/muster/react';
import BacklinkWrapper from '../../components/common/backlink-wrapper';
import URLResolver from '../../../src/utils/url-resolver';
import settings from '../../../src/data/settings.json';

class DbkLibraryScreen extends Component {

    constructor(props) {
        super(props);
        this.update = this.update.bind(this);
    }


    componentDidMount() {

    }
    // callback function triggered from component screen
    update() {
        this.props.goBack()
    }

    render = () => {

        const RosterData = this.props.app.global.roster.root;

        return (


                <BacklinkWrapper
                    removeOverride={false}
                    onBacklinkClicked={() => {
                        this.component.method()
                    }}>
                    {/* <DwoComponentWeb callBack={this.update}
                    roster_url={URLResolver.getRemoteURL()}
                    buildEnvironmentSettings={settings}
                    onRef={ref => (this.component = ref)}
                    roster_data={RosterData}
                    initial_path={this.props.ui.component.initialPath} /> */}
                </BacklinkWrapper>
        )
    };
}


// app.global.roster.root
export default createContainer({
    $queries: {
        goBack: { $call: 'ui.history.goBack' },
        setComponentProps: {
            $set: 'ui.componentProps'
        },
        ui: {
            component: {
                initialPath: true,
                initialPathGuid: true
            },
        },
        app: {
            global: {
                roster: {
                    root: true
                }
            },
        },
        i18n: {
            messages: true,
        },
    },
})(DbkLibraryScreen);
